import React from 'react';

interface BotaoSubmitProps {
  isLoading: boolean;
  texto: string;
  textoLoading: string;
  className?: string;
}

const BotaoSubmit: React.FC<BotaoSubmitProps> = ({
  isLoading,
  texto,
  textoLoading,
  className = 'btn btn-success',
}) => {
  return (
    <button type="submit" className={className} disabled={isLoading}>
      {isLoading ? (
        <>
          <span
            className="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Salvando...</span>
          {textoLoading}
        </>
      ) : (
        texto
      )}
    </button>
  );
};

export default BotaoSubmit;
